<template>
    <div
        v-if="address"
        :class="{'cursor-pointer': !hideShowOnMapButton, 'order-info-base-info': isShowLabel}"
        @click.stop="showOnMap"
    >
        <span v-if="isShowLabel" class="hotel-address__item order-info-base-info__icon">
            <v-icon start size="x-small">mdi-map-marker-outline</v-icon>
            <span class="text-body-2">{{ $t('location') }}</span>
        </span>
        <span class="d-flex align-center flex-wrap gc-1" :class="{'order-info-base-info__text': isShowLabel}">
            <v-icon v-if="!isShowLabel" :start="isShowLabel" size="x-small">mdi-map-marker-outline</v-icon>
            {{ address }}
            <span
                v-if="!hideShowOnMapButton"
                class="hotel-address__show-map text-body-2 text-link text-decoration-underline text-lowercase"
            >
                {{ $t('show_on_map') }}
            </span>
        </span>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import {CHANGE_TAB_MOBILE_EVENT, EventBus, SHOW_ON_MAP_EVENT} from '@/utils/event-bus'

    @Component
    export class HotelAddressLabel extends Vue {
        @Prop({required: true}) address
        @Prop() offer
        @Prop({default: false, type: Boolean}) isShowLabel
        @Prop({default: false, type: Boolean}) hideShowOnMapButton

        showOnMap() {
            this.$emit('click')
            if (!this.offer || this.hideShowOnMapButton) return
            if (this.$breakpoint.smAndDown) {
                EventBus.$emit(CHANGE_TAB_MOBILE_EVENT, 2)
            }
            EventBus.$emit(SHOW_ON_MAP_EVENT, this.offer)
        }
    }

    export default HotelAddressLabel
</script>
